import React, { useState } from 'react'
import { AntTabs, AntTab } from './common/Tabs'
import ResourceEmprelCoachings from './ResourceEmprelCoachings'
import ResourceEmprelCorrective from './ResourceEmprelCorrective'
import ResourceEmprelDisputes from './ResourceEmprelDisputes'

const tabs = [
  { display: 'Coachings', value: 0 },
  { display: 'Corrective Actions', value: 1 },
  { display: 'Disputes', value: 2 }
]

export default function ResourceEmployeeRelations(props) {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='employee relations tabs'
      >
        {tabs.map((cur, index) => (
          <AntTab
            key={index}
            label={cur.display}
            value={cur.value}
            color={props.fetchInitialData.credentials.primaryAppColor}
          />
        ))}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <ResourceEmprelCoachings {...props} />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <ResourceEmprelCorrective {...props} />
        </div>
      )}
      {value === 2 && (
        <div style={{ marginTop: '1rem' }}>
          <ResourceEmprelDisputes {...props} />
        </div>
      )}
    </>
  )
}
